<template>
<div>
<div class="grid-nogutter">
<div class="col-12 mt-4" >
<span class="p-float-label mb-4 mt-0">
  <InputText id="template_name"  v-model="new_template.name" class="w-full p-inputtext-sm"  ref="template_name" />
  <label for="template_name"  >{{$store.state.languages.lang_phrases.isim}}</label>
</span>

<span class="p-float-label mb-4 mt-0">
  <Textarea id="template_description" v-model="new_template.description" class="w-full p-inputtext-sm"   rows="4" ref="template_description"/>
  <label for="template_description"  >{{$store.state.languages.lang_phrases.aciklama}}</label>
</span>
</div> 

</div>

<div class="grid-nogutter flex justify-content-between">
<div class="col-12 flex-column  align-items-end">
<Button  :label="show_filters_lable" class="p-button-secondary p-button-outlined  p-button-sm mr-2"  :icon="filter_btn_icon" @click="toggleFilters" ></Button>
</div>
</div>



<Transition name="fade">
<ScrollPanel style="width: 100%; height: 43vh;margin-top:10px" v-if="show_filters">
<div class="grid" >
<template v-if="preparing_filters">
<div class="col-12 flex justify-content-center">
<FrameOverlay></FrameOverlay>
</div>
</template>
<template v-else>	
</template>
</div>



<TabView>
<!-- standart filters-->
<TabPanel >

<template #header>
<div class="flex align-items-center gap-1">
    
    <span class="text-sm white-space-nowrap">Standart Filtreler</span>
    <Badge :value="getStandartFiltersCount()" v-if="getStandartFiltersCount()"/>
</div>
</template>


<div class="grid">
<!-- brands -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.markalar}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="brand in brands"
class="ml-2  mb-1 custom-chip" 
:value="brand.name" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- brands -->

<!-- projects -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.projeler}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="project in projects"
class="ml-2  mb-1 custom-chip" 
:value="getTheTranslation(project,'translation')" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- projects -->

<!-- periods -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.proje_donemleri}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="period in periods"
class="ml-2  mb-1 custom-chip" 
:value="period.name" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- periods -->

<!-- flows -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.akislar}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="flow in flows"
class="ml-2  mb-1 custom-chip" 
:value="getTheTranslation(flow,'translation')" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- flows -->

<!-- flow_type -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.aktif_akis}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="active_flow in active_flows"
class="ml-2  mb-1 custom-chip" 
:value="getFlowType(active_flow)" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- flow_type -->

<!-- status -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.durum}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="status in statuses"
class="ml-2  mb-1 custom-chip" 
:value="getStatusType(status)" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- status -->

<!-- created_at -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.eklenme_tarihi}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="created_at_item in created_at"
class="ml-2  mb-1 custom-chip" 
:value="created_at_item" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- created_at -->

<!-- scheduled_at -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.oturum_tarihi}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="scheduled_at_item in scheduled_at"
class="ml-2  mb-1 custom-chip" 
:value="scheduled_at_item" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- scheduled_at -->

<!-- auditors -->
<div class="col-3">
<p class="font-medium m-0">{{$store.state.languages.lang_phrases.denetci}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="auditor in auditors"
class="ml-2  mb-1 custom-chip" 
:value="auditor.name" 
style="'background-color:#352f8d'"
/> 
</div>
<!-- auditors -->

</div>

</TabPanel>
<!-- standart filters-->

<!-- customattributefilters -->
<TabPanel >

<template #header>
<div class="flex align-items-center gap-1">    
    <span class="text-sm white-space-nowrap">Özel Nitelik Filtreleri</span>
    <Badge :value="getCustomAttributeFiltersCount()" v-if="getCustomAttributeFiltersCount()"/>
</div>
</template>

<div class="grid">
<template v-for="customattributefilter in customattributefilters">

<template v-if="customattributefilter.type=='select'">
<div class="col-3">
<p class="font-medium m-0">{{customattributefilter.name}}:</p>  
</div>
<div class="col-9">
<Tag 
v-for="option in getCustomAttributeFilterOutput(customattributefilter)"
class="ml-2  mb-1 custom-chip" 
:value="getTheTranslation(option,'translation')" 
style="'background-color:#352f8d'"
/> 
</div>
</template>

</template>
</div>
</TabPanel>
<!-- customattributefilters -->

<!-- brand_columns -->
<TabPanel >

<template #header>
<div class="flex align-items-center gap-1">
    
    <span class="text-sm white-space-nowrap">Marka Sütunları</span>
    <Badge :value="getBrandColumnsCount()"  v-if="getBrandColumnsCount()"/>
</div>
</template>
<div class="grid">
<template v-for="brand_column in brand_columns">
  <template v-if="brand_column.columntype=='text'">
    
  </template>

  <template v-if="brand_column.columntype=='select'">
    <div class="col-3">
    <p class="font-medium m-0">{{brand_column.name}}:</p>  
    </div>
    <div class="col-9">
    <Tag 
    v-for="option in getBrandColumnOutput(brand_column)"
    class="ml-2  mb-1 custom-chip" 
    :value="option.name" 
    style="'background-color:#352f8d'"
    /> 
    </div>
  </template>

  <template v-if="brand_column.columntype=='date'">
    <div class="col-3">
    <p class="font-medium m-0">{{brand_column.name}}:</p>  
    </div>
    <div class="col-9">
    <Tag 
    v-for="option in getBrandColumnOutput(brand_column)"
    class="ml-2  mb-1 custom-chip" 
    :value="option" 
    style="'background-color:#352f8d'"
    /> 
    </div>
  </template>
    
</template>
</div>
</TabPanel>
<!-- brand_columns -->

</TabView>



</ScrollPanel>
</Transition>








<div class="grid-nogutter">
<div class="col-12"><hr></div>
<div class="col-12 flex justify-content-end" >
<Button  
:label="$store.state.languages.lang_phrases.iptal" 
class="p-button-danger p-button-outlined  p-button-sm mr-2"  
icon="pi pi-times" 
:loading="submitting"
@click="hideNewFilterForm" ></Button>
<Button  
:label="$store.state.languages.lang_phrases.kaydet" 
class="p-button-primary p-button-outlined  p-button-sm "  
icon="pi pi-plus"  
:loading="submitting"
@click="submitFilterTemplate"></Button>

</div>
</div>

</div>
</template>

<script>
import moment from "moment"
export default {

  name: 'PlannerTableTemplateSidebarForm',
  props:["schema","customattributefilters","brand_columns","pagetype"],
  data () {
    return {    	
      new_template:{
        name:null,
        description:null,
        schema:null,
        brand_id:null,
      },   
      submitting:false,   
      show_filters:false,
      preparing_filters:true,
      brands:[],
      projects:[],
      periods:[],
      flows:[],
      active_flows:[],
      statuses:[],
      auditors:[],
      created_at:[],
      scheduled_at:[],
      time_periods:[
        {id:"thisweek",name:"Bu Hafta"},
        {id:"thismonth",name:"Bu Ay"},
        {id:"thisquarter",name:"Bu Çeyrek"},
        {id:"thisyear",name:"Bu Yıl"},
        {id:"lastweek",name:"Son 1 Hafta"},
        {id:"lastfifteendays",name:"Son 15 Gün"},
        {id:"lastthirtydays",name:"Son 30 Gün"},
        {id:"lastninetydays",name:"Son 90 Gün"},
        {id:"lastoneeightydays",name:"Son 180 Gün"},
      ],

    }
  },
  computed:{
    flowtypes()
    {
      if(this.pagetype=="verification")
      {
        return ['verification', 'self_evaluation']
      }
      if(this.pagetype=="audit")
      {
        return ['audit']
      }
    },
    status_types()
    {
      if(this.pagetype=="verification")
      {
        return ['awaiting_schedule', 'scheduled', 'rescheduled',"started","under_review","finished","deleted"]
      }

      if(this.pagetype=="preaudit")
      {
        return ['awaiting_schedule', 'scheduled', 'rescheduled',"added_to_verification","deleted"]
      }

      if(this.pagetype=="audit")
      {
        return ['awaiting_schedule', 'scheduled', 'rescheduled',"started","under_review","finished","exempt","deleted"]
      }
      
    },
  	show_filters_lable()
  	{
  	  if(this.show_filters)
      {
        return this.$store.state.languages.lang_phrases.gizle
      }
      return this.$store.state.languages.lang_phrases.filtre_ayarlarini_goster
  	},
  	filter_btn_icon()
  	{
  		if(this.show_filters)
  		{
  			return "pi pi-eye-slash"
  		}
  		return "pi pi-eye"
  	}
  },
  watch:{
  	show_filters()
  	{
  		if(this.show_filters)
  		{
  			this.prepareFilters()
  		}
  	}
  },
  methods:{ 
    getStandartFiltersCount()
    {
      let items = this.sanitizeArray(this.schema)
      let count = 0
      for (const property in items) {
        if(!property.includes("column") && items[property].value&& items[property].value.length)
        {
          count++
        }
      }
      return count
    },
    getBrandColumnsCount()
    {
      let items = this.sanitizeArray(this.schema)
      let count = 0
      for (const property in items) {
        if(property.includes("column") && items[property].value&& items[property].value.length)
        {
          count++
        }
      }
      return count
    },
    getCustomAttributeFiltersCount()
    {
      return this.customattributefilters.length
    },
    submitFilterTemplate()
    {    
      
      if(!this.new_template.name || this.new_template.name=="")
      {
        this.showMessage("error","Lütfen bir isim belirleyim")
        this.$el.querySelector("#template_name").focus();
        return false
      }
      if(!this.new_template.description || this.new_template.description=="")
      {
        this.showMessage("error","Lütfen bir açıklama girin")
        this.$el.querySelector("#template_description").focus();
        return false
      }
      this.submitting = true

      let schema = this.sanitizeArray(this.schema)
      console.log(schema)

      let customattributefilters = this.sanitizeArray(this.customattributefilters)
      console.log(customattributefilters)

      let formdata = new FormData()
      let filter = {
        schema:schema,
        customattributefilters:customattributefilters,
      }
      if(schema.brand_name.value.length===1)
      {
        formdata.append("brand_id",schema.brand_name.value[0])
      }      
      
      formdata.append("name",this.new_template.name)
      formdata.append("description",this.new_template.description)
      formdata.append("filter",JSON.stringify(filter))
      this.generalSubmission(formdata,"planningfiltertemplate/submit_filter_template",this.aftersubmitFilterTemplate)


    },
    aftersubmitFilterTemplate(response)
    {
      this.$emit("hideNewFilterForm")
      this.submitting = true
    },
    getCustomAttributeFilterOutput(customattributefilter)
    {
      let output
      //select
      if(customattributefilter.type=="select")
      {        
        output = []
        for(let option of customattributefilter.options)
        {
          let the_option = customattributefilter.fulloptions.find(item=>item.id == option)
          if(the_option)
          {
          output.push(the_option)
          }
        }
      }
      //select
      console.log(output)
      return output
    },
    getBrandColumnOutput(brand_column)
    {
      let output
      let data = this.schema["column_"+brand_column.id]
      if(data)
      {
        //select
        if(brand_column.columntype=="select")
        {          
          output = []
          if(data.value && data.value.length)
          {
            for(let value in data.value)
            {
              let option = brand_column.options.find(item=>item.id == data.value[value])
              if(option)
              {
                output.push(option)
              }
            }
          }
        }
        //select
        //date
        if(brand_column.columntype=="date")
        {
          output = []
          if(data.value && data.value.length)
          {
            if(this.schema["column_"+brand_column.id].time_period)
            {
              let time_period = this.time_periods.find(item=>item.id == this.schema["column_"+brand_column.id].time_period)
              output.push(time_period.name)
            }
            else
            {
              let start = this.schema["column_"+brand_column.id].value[0]
              let end = this.schema["column_"+brand_column.id].value[1]
              output.push(moment(start).format('L'))
              output.push(moment(end).format('L'))
            }

          }
        }
        //date
      }
      
      return output
    },
    getFlowType(type)
    {
      let term= this.flowtypes.find(item=>item == type)
      if(term=="self_evaluation")
      {
        return this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(term=="verification")
      {
        return this.$store.state.languages.lang_phrases.verification
      }
      if(term=="audit")
      {
        return this.$store.state.languages.lang_phrases.audit
      }

    },
    getStatusType(type)
    {
      let term= this.status_types.find(item=>item == type)
      if(term=="awaiting_schedule")
      {
        return this.$store.state.languages.lang_phrases.planlama_bekliyor
      }
      if(term=="scheduled")
      {
        return this.$store.state.languages.lang_phrases.planlandi
      }
      if(term=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(term=="exempt")
      {
        return this.$store.state.languages.lang_phrases.muaf
      }
      if(term=="rescheduled")
      {
        return this.$store.state.languages.lang_phrases.tekrar_planlandi
      }
      if(term=="on_planning")
      {
        return this.$store.state.languages.lang_phrases.planlamada
      }
      if(term=="under_review")
      {
        return this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(term=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(term=="added_to_verification")
      {
        return this.$store.state.languages.lang_phrases.dogrulamaya_aktarildi
      }
      if(term=="deleted")
      {
        return this.$store.state.languages.lang_phrases.iptal_edildi
      }
    },
    hideNewFilterForm()
    {
      this.$emit("hideNewFilterForm")
    },
    toggleFilters()
    {
    	this.show_filters = !this.show_filters
    },
    async prepareFilters()
    {
    	this.preparing_filters = true
    	//get brands
    	if(this.schema.brand_name.value && this.schema.brand_name.value.length)
    	{
    		this.brands = await this.generalApiGetWithoutLoader("get_selected_brands?brands="+JSON.stringify(this.schema.brand_name.value)) 
    	}
    	//get brands
    	//get projects
      if(this.schema.project_name.value && this.schema.project_name.value.length)
      {
        this.projects = await this.generalApiGetWithoutLoader("get_selected_projects?projects="+JSON.stringify(this.schema.project_name.value)) 
      }
      //get projects
      //get periods
      if(this.schema.projectperiod_name.value && this.schema.projectperiod_name.value.length)
      {
        this.periods = await this.generalApiGetWithoutLoader("get_selected_periods?periods="+JSON.stringify(this.schema.projectperiod_name.value)) 
      }
      //get periods
      //get flows
      if(this.schema.flow_name.value && this.schema.flow_name.value.length)
      {
        this.flows = await this.generalApiGetWithoutLoader("get_selected_flows?flows="+JSON.stringify(this.schema.flow_name.value)) 
      }
      //get flows
      //get auditors
      if(this.schema.auditor_name.value && this.schema.auditor_name.value.length)
      {
        this.auditors = await this.generalApiGetWithoutLoader("get_selected_auditors?auditors="+JSON.stringify(this.schema.auditor_name.value)) 
      }
      //get auditors

      //get flow_type
      if(this.schema.flow_type.value && this.schema.flow_type.value.length)
      {
        this.active_flows = this.schema.flow_type.value 
      }
      //get flow_type

      //get status
      if(this.schema.status.value && this.schema.status.value.length)
      {
        this.statuses = this.schema.status.value 
      }
      //get status

      //get created_at
      if(this.schema.created_at.value && this.schema.created_at.value.length)
      {
        if(this.schema.created_at.time_period)
        {
          let time_period = this.time_periods.find(item=>item.id == this.schema.created_at.time_period)
          
          this.created_at.push(time_period.name)
          
        }
        else
        {
          let start = this.schema.created_at.value[0]
          let end = this.schema.created_at.value[1]
          this.created_at.push(moment(start).format('L'))
          this.created_at.push(moment(end).format('L'))
        }
      }
      //get created_at

      //get scheduled_at
      if(this.schema.scheduled_at.value && this.schema.scheduled_at.value.length)
      {
        if(this.schema.scheduled_at.time_period)
        {
          let time_period = this.time_periods.find(item=>item.id == this.schema.scheduled_at.time_period)
          
          this.scheduled_at.push(time_period.name)
          
        }
        else
        {
          let start = this.schema.scheduled_at.value[0]
          let end = this.schema.scheduled_at.value[1]
          this.scheduled_at.push(moment(start).format('L'))
          this.scheduled_at.push(moment(end).format('L'))
        }
      }
      //get scheduled_at

      

    	this.preparing_filters = false
    	
    },
    calculateTimePeriod(column_type)
    {

    }
  }
}
</script>

<style lang="css" scoped>
.fade-enter-active,.fade-leave-active {
  transition: opacity;
}
.fade-enter,.fade-leave-active {
  opacity: 0
}
</style>